import WarningFilled from '@ant-design/icons/WarningFilled';
import Empty from 'antd/lib/empty';
import Timeline from 'antd/lib/timeline/Timeline';
import Typography from 'antd/lib/typography';
import { orderBy } from 'lodash';
import { getComputerFormattedTime } from 'src/domain/date/date';
import { ICustomerVenLog } from 'src/domain/ven/logs/interface';
import './CustomerVenLogsTimeline.css';

interface CustomerVenLogsTimelineProps {
    logs: ICustomerVenLog[];
}

export const CustomerVenLogsTimeline = ({ logs }: CustomerVenLogsTimelineProps) => {
    const preparedLogs = orderBy(logs, ['timestamp'], ['desc']);

    if (preparedLogs.length === 0) {
        return <Empty key="logs-empty" image={Empty.PRESENTED_IMAGE_SIMPLE} />;
    }

    return (
        <div style={{ padding: '10px 0' }}>
            <Timeline
                className="customer-ven-logs-timeline"
                items={preparedLogs.map(preparedLog => {
                    const formattedDateTime = getComputerFormattedTime(new Date(preparedLog.timestamp), 'dd/MMM/yyyy hh:mm:ss.SSS a zzz');

                    return {
                        ...makeTimelineItemIcon(preparedLog),
                        children: (
                            <>
                                <div className="logs-line-datetime">{formattedDateTime}</div>
                                <Typography.Text code>{preparedLog.message}</Typography.Text>
                            </>
                        ),
                    };
                })}
            />
        </div>
    );
};

function makeTimelineItemIcon(it: ICustomerVenLog) {
    switch (it.level) {
        case 'INFO':
            return { color: 'blue' };
        case 'DEBUG':
            return { color: 'grey' };
        case 'ERROR':
            return { color: 'red', dot: <WarningFilled color="red" style={{ fontSize: '18px' }} /> };
        case 'WARN':
            return { color: 'orange', dot: <WarningFilled color="orange" style={{ fontSize: '18px' }} /> };
        default:
            return { color: 'blue' };
    }
}
